import styled from 'styled-components';

export const OwnerInfoContainer = styled.div`
  display: flex;
  flex-direction: column;
  margin-top: 30px;
  padding: 18px;
  border-radius: 8px;
  background-color: ${({ theme }) => theme.colors.color_bg};
  font-size: ${({ theme }) => theme.fontSize.nm};

  &.purchase {
    margin-top: 0;
  }

  @media (max-width: 1024px) {
    margin-top: 10px;
  }

  @media (max-width: 512px) {
    border-radius: 0;
    padding: 16px 6px 6px;
  }
`;

export const Header = styled.div`
  font-size: ${({ theme }) => theme.fontSize.xm};

  @media (max-width: 512px) {
    font-size: ${({ theme }) => theme.fontSize.xn};
  }
`;

export const Contacts = styled.div`
  margin-top: 21px;
`;

export const FirmInfoWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  flex-wrap: wrap;
`;

export const ButtonContainer = styled.div`
  padding-top: 10px;
  flex: 1;

  .button {
    width: 100%;

    button {
      width: 100%;
    }
  }
`;
